<template>
  <div>
    <mx-page type="Home" theme="Panel" class="p10" title="已邀学员" name="已邀学员" :config="config" :parent="value" :parent-type="config.Type" />
  </div>
</template>
<script>
export default {
  props: {
    value: Object,
    config: Object
  }
}
</script>
